<template>
  <div class="global-ftr">
    <div>運営：国土技術研究センター</div>
  </div>
</template>
